module.exports = __webpack_public_path__ + "img/right.389d551b.png";